/* SYNESTHESIA CUSTOM CODE START */

window.addEventListener('DOMContentLoaded', () => {
    const checkbox = document.getElementById('checkbox_privacy_cart');

    // Procedi solo se il checkbox esiste nella pagina
    if (checkbox) {
      const isChecked = localStorage.getItem('checkbox_privacy_cart') === 'true';
      checkbox.checked = isChecked;

      checkbox.addEventListener('change', () => {
        localStorage.setItem('checkbox_privacy_cart', checkbox.checked);
      });
    }else{
      localStorage.setItem('checkbox_privacy_cart', false);
    }
  });


document.addEventListener('DOMContentLoaded', function () {




  const swiper = document.querySelector('.swiper-container');
  
  const targetElement = document.querySelector('[data-pp-amount]');

  function getNumericPrice(text) {
    return text.trim().replace(/[^\d,.]/g, '').replace(',', '.');
  }

  function updateAmountFromPrice() {
    const priceElement = document.querySelector('.wt-product__main .wt-product__price__final');
    if (priceElement && targetElement) {
      const newPrice = getNumericPrice(priceElement.textContent);
      targetElement.setAttribute('data-pp-amount', newPrice);
      console.log('Prezzo aggiornato:', newPrice);
    }
  }

  if (swiper) {
    swiper.addEventListener('click', function () {
      setTimeout(updateAmountFromPrice, 1000);

    });
  }
});



/* CUSTOM CART */

if (document.querySelector('.template-cart')) {

  document.querySelector('body').addEventListener('click', event => {
    if (event.target.matches('#checkout_sticky') || event.target.matches('#checkout') || event.target.closest('#checkout_sticky') || event.target.closest('#checkout')) {
      var agree = document.querySelector("#checkbox_privacy_cart");
      var agree_error = document.querySelector("#checkout-is-required-input");
      if (!agree.checked) {
        event.preventDefault();
        agree_error.removeAttribute("hidden");
        agree_error.focus();
      } else {
        const inputNames = [
          'attributes[Fidelity card]',
          'attributes[Ragione sociale]',
          'attributes[Indirizzo]',
          'attributes[CAP]',
          'attributes[Città]',
          'attributes[Provincia]',
          'attributes[Partita IVA]'
        ];

        inputNames.forEach(function(name) {
            var input = document.querySelector(`input[name="${name}"],select[name="${name}"]`);
            if (input && input.required && (!input.value || input.value == '')) {
                event.preventDefault();
                var errorElementId = input.getAttribute("data-error-id");
                var errorElement = document.querySelector("#" + errorElementId);
                if (errorElement) {
                    errorElement.removeAttribute("hidden");
                }
                input.focus();
            }
            else if (input && input.required && input.value) {
                var errorElementId = input.getAttribute("data-error-id");
                var errorElement = document.querySelector("#" + errorElementId);
                if (errorElement) {
                    errorElement.setAttribute("hidden",true);
                }
            }
        });

        var partitaIvaCheckbox = document.querySelector('.custom-radio-partita-iva:checked').value;
        var codiceSDIInput = document.querySelector('input[name="attributes[Codice SDI]"]');
        var indirizzoPECInput = document.querySelector('input[name="attributes[Indirizzo PEC]"]');
        if (partitaIvaCheckbox === 'Si' && !codiceSDIInput.value && !indirizzoPECInput.value) {
          event.preventDefault();
          var codiceSDI_error = document.querySelector("#codiceSDI_error-is-required-input");
          codiceSDI_error.removeAttribute("hidden");
          codiceSDIInput.focus();
        }
      }
    }
  });
  
  
  
  
  // Trigger the change event initially
  document.querySelectorAll('.custom-radio-fidelity').forEach(function(element) {
    var event = new Event('change');
    element.dispatchEvent(event);
  });
  
  
  document.addEventListener('change', function(e) {
    if (e.target && e.target.classList.contains('custom-cart-pacchetto-regalo-radio')) {
      var thisRow = e.target.closest('tr');
      var fraseElement = e.target.closest('.cart-regalo-option-wrap').querySelector('.custom-frase-pacchetto-regalo');
      var thisFrase = fraseElement ? fraseElement.value : '';

      var Misura = e.target.closest('.custom-cart-pacchetto-regalo').querySelector('.misura-value').value;
      
      if(Misura != ''){
        var proprietsToChange = {
            'Pacchetto regalo': e.target.value,
            'Frase biglietto auguri': thisFrase,
            'Misura': Misura
          }
      }else{
        var proprietsToChange = {
            'Pacchetto regalo': e.target.value,
            'Frase biglietto auguri': thisFrase
          }
      }
  
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          line: e.target.getAttribute('data-line'),
          properties: proprietsToChange
        })
      });
  
      thisRow.querySelectorAll('.custom-cart-pacchetto-regalo-radio.active').forEach(function(el) {
        el.classList.remove('active');
      });
      e.target.classList.add('active');
  
      thisRow.querySelectorAll('.custom-frase-pacchetto-regalo-wrap').forEach(function(el) {
        el.style.display = 'none';
      });
      var fraseWrapElement = e.target.closest('.cart-regalo-option-wrap').querySelector('.custom-frase-pacchetto-regalo-wrap');
      if (fraseWrapElement) {
        fraseWrapElement.style.display = 'block';
      }
    }
  });
  
  
  document.addEventListener('blur', function(e) {
    if (e.target && e.target.classList.contains('custom-frase-pacchetto-regalo')) {
      var thisPacchetto = e.target.closest('.cart-regalo-option-wrap').querySelector('.custom-cart-pacchetto-regalo-radio').value;
      var thisFrase = e.target.value;
  
      var Misura = e.target.closest('.custom-cart-pacchetto-regalo').querySelector('.misura-value').value;
      
      //console.log('Misura: ' + Misura);

      if(Misura != ''){
        var proprietsToChange = {
            'Pacchetto regalo': thisPacchetto,
            'Frase biglietto auguri': thisFrase,
            'Misura': Misura
          }
      }else{
        var proprietsToChange = {
            'Pacchetto regalo': thisPacchetto,
            'Frase biglietto auguri': thisFrase
          }
      }
  
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          line: e.target.getAttribute('data-line'),
          properties: proprietsToChange
        })
      });
    }
  }, true);
  
  
  document.addEventListener('keydown', updateFrasePacchetto);
  document.addEventListener('keyup', updateFrasePacchetto);
  
  function updateFrasePacchetto(e) {
    if (e.target && e.target.classList.contains('custom-frase-pacchetto-regalo')) {
      var thisValue = e.target.value;
      e.target.closest('.cart-regalo-option-wrap').siblings('.cart-regalo-option-wrap').forEach(function(sibling) {
        sibling.querySelectorAll('.custom-frase-pacchetto-regalo').forEach(function(input) {
          input.value = thisValue;
        });
      });
    }
  }
  
  Element.prototype.siblings = function(selector) {
    return Array.from(this.parentNode.children).filter(function(child) {
      return child !== this && (!selector || child.matches(selector));
    }, this);
  };
  
  
  
  
  
  
  document.querySelectorAll('.custom-radio-fidelity').forEach(function(element) {
    element.addEventListener('change', function() {
      var checkedValue = document.querySelector('.custom-radio-fidelity:checked').value;
  
      if (checkedValue === 'Si') {
        document.querySelectorAll('.cart-custom-field-fidelity').forEach(function(field) {
          field.style.display = 'block';
        });
        document.querySelectorAll('.cart-custom-field-fidelity.cart-custom-field-fidelity-required input,.cart-custom-field-fidelity.cart-custom-field-fidelity-required select').forEach(function(input) {
          input.required = true;
          input.classList.add('required');
        });
      } else {
        document.querySelectorAll('.cart-custom-field-fidelity').forEach(function(field) {
          field.style.display = 'none';
        });
        document.querySelectorAll('.cart-custom-field-fidelity input,.cart-custom-field-fidelity select').forEach(function(input) {
          input.value = '';
        });
        document.querySelectorAll('.cart-custom-field-fidelity.cart-custom-field-fidelity-required input,.cart-custom-field-fidelity.cart-custom-field-fidelity-required select').forEach(function(input) {
          input.required = false;
          input.classList.remove('required');
        });
  
        var fidelity_error = document.querySelector("#fidelity-is-required-input");
        fidelity_error.setAttribute("hidden", true);
  
        // Svuota il valore dell'input prima di inviare la richiesta
        var formData = new FormData();
        formData.append("attributes[Fidelity card?]", checkedValue);
        formData.append("attributes[Fidelity card]", "");
        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          body: formData
        })
        .then(response => response.json())
        .then(data => console.log(data))
        .catch(error => console.error('Error:', error));
  
        // Uscire dalla funzione per evitare la doppia richiesta
        return;
      }
  
      // Invio del valore dell'input radio al server
      var formData = new FormData();
      formData.append("attributes[Fidelity card?]", checkedValue);
  
      // Se il valore selezionato è 'Si', aggiungi anche il valore dell'input aggiuntivo
      if (checkedValue === 'Si') {
        var fidelityInputValue = document.querySelector('input[name="attributes[Fidelity card]"]').value;
        formData.append("attributes[Fidelity card]", fidelityInputValue);
      }
  
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => console.log(data))
      .catch(error => console.error('Error:', error));
    });
  });
  
  // Aggiungi listener per l'evento blur sull'input name="attributes[Fidelity card]"
  /*
  document.querySelector('input[name="attributes[Fidelity card]"]').addEventListener('blur', function() {
    var fidelityInputValue = this.value;
    var formData = new FormData();
    formData.append("attributes[Fidelity card]", fidelityInputValue);
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(data => console.log(data))
    .catch(error => console.error('Error:', error));
  });
  */


  // Definisci i nomi degli input da controllare
  const inputNames = [
    'attributes[Fidelity card]',
    'attributes[Ragione sociale]',
    'attributes[Indirizzo]',
    'attributes[CAP]',
    'attributes[Città]',
    'attributes[Provincia]',
    'attributes[Partita IVA]',
    'attributes[Codice SDI]',
    'attributes[Indirizzo PEC]'
  ];
  
  inputNames.forEach(name => {
    const input = document.querySelector(`input[name="${name}"],select[name="${name}"]`);
    if (input) {
      input.addEventListener('blur', function() {
        var formData = new FormData();
  
        inputNames.forEach(name => {
          const input = document.querySelector(`input[name="${name}"],select[name="${name}"]`);
          if (input) {
            formData.append(name, input.value);
          }
        });
  
        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          body: formData
        })
        .then(response => response.json())
        .then(data => console.log(data))
        .catch(error => console.error('Error:', error));
      });
    }
  });

  // Trigger del cambiamento iniziale
  document.querySelectorAll('.custom-radio-fidelity').forEach(function(element) {
    var event = new Event('change');
    element.dispatchEvent(event);
  });

  document.querySelectorAll('.custom-radio-partita-iva').forEach(function(element) {
    element.addEventListener('change', function() {
      var checkedValue = document.querySelector('.custom-radio-partita-iva:checked').value;
  
      if (checkedValue === 'Si') {
        document.querySelectorAll('.cart-custom-field-billing-group,.cart-custom-field-billing').forEach(function(field) {
          field.style.display = 'block';
        });
        document.querySelectorAll('.cart-custom-field-billing.cart-custom-field-billing-required input').forEach(function(input) {
          input.required = true;
          input.classList.add('required');
        });
        document.querySelectorAll('.cart-custom-field-billing.cart-custom-field-billing-required select').forEach(function(input) {
          input.required = true;
          input.classList.add('required');
        });
      } else {
        document.querySelector('.cart-custom-field-billing-group').style.display = 'none';
        document.querySelectorAll('cart-custom-field-billing-group,.cart-custom-field-billing').forEach(function(field) {
          field.style.display = 'none';
        });
        document.querySelectorAll('.cart-custom-field-billing input').forEach(function(input) {
          input.value = '';
        });
        document.querySelectorAll('.cart-custom-field-billing select').forEach(function(input) {
          input.selectedIndex = 0; 
        });
        document.querySelectorAll('.cart-custom-field-billing.cart-custom-field-billing-required input').forEach(function(input) {
          input.required = false;
          input.classList.remove('required');
        });
        document.querySelectorAll('.cart-custom-field-billing.cart-custom-field-billing-required select').forEach(function(input) {
          input.required = false;
          input.classList.remove('required');
        });
  
        //var fidelity_error = document.querySelector("#fidelity-is-required-input");
        //fidelity_error.setAttribute("hidden", true);

        document.querySelectorAll('.cart-custom-field-billing-group .invalid-feedback span').forEach(function(iva_error) {
          iva_error.setAttribute("hidden", true);
        });

        
  
        // Svuota il valore dell'input prima di inviare la richiesta
        var formData = new FormData();
        formData.append("attributes[Vuoi ricevere la fattura?]", checkedValue);
        formData.append("attributes[Ragione sociale]", "");
        formData.append("attributes[Indirizzo]", "");
        formData.append("attributes[CAP]", "");
        formData.append("attributes[Città]", "");
        formData.append("attributes[Provincia]", "");
        formData.append("attributes[Partita IVA]", "");
        formData.append("attributes[Codice SDI]", "");
        formData.append("attributes[Indirizzo PEC]", "");
        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          body: formData
        })
        .then(response => response.json())
        .then(data => console.log(data))
        .catch(error => console.error('Error:', error));
  
        // Uscire dalla funzione per evitare la doppia richiesta
        return;
      }
  
      // Invio del valore dell'input radio al server
      var formData = new FormData();
      formData.append("attributes[Vuoi ricevere la fattura?]", checkedValue);
  
      // Se il valore selezionato è 'Si', aggiungi anche il valore dell'input aggiuntivo
      if (checkedValue === 'Si') {
        var ragioneSocialeValue = document.querySelector('input[name="attributes[Ragione sociale]"]').value;
        formData.append("attributes[Ragione sociale]", ragioneSocialeValue);

        var indirizzoValue = document.querySelector('input[name="attributes[Indirizzo]"]').value;
        formData.append("attributes[Indirizzo]", indirizzoValue);

        var capValue = document.querySelector('input[name="attributes[CAP]"]').value;
        formData.append("attributes[CAP]", capValue);

        var cittaValue = document.querySelector('input[name="attributes[Città]"]').value;
        formData.append("attributes[Città]", cittaValue);

        var provinciaValue = document.querySelector('select[name="attributes[Provincia]"]').value;
        formData.append("attributes[Provincia]", provinciaValue);

        var partitaIVAValue = document.querySelector('input[name="attributes[Partita IVA]"]').value;
        formData.append("attributes[Partita IVA]", partitaIVAValue);

        var codiceSDIValue = document.querySelector('input[name="attributes[Codice SDI]"]').value;
        formData.append("attributes[Codice SDI]", codiceSDIValue);

        var indirizzoPECValue = document.querySelector('input[name="attributes[Indirizzo PEC]"]').value;
        formData.append("attributes[Indirizzo PEC]", indirizzoPECValue);
      }
  
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => console.log(data))
      .catch(error => console.error('Error:', error));
    });
  });

  // Trigger del cambiamento iniziale
  document.querySelectorAll('.custom-radio-partita-iva').forEach(function(element) {
    var event = new Event('change');
    element.dispatchEvent(event);
  });

}


  document.querySelectorAll('.custom-radio-partita-iva').forEach(function(element) {
    element.addEventListener('change', function() {
      var checkedValue = document.querySelector('.custom-radio-partita-iva:checked').value;
  
      if (checkedValue === 'Si') {
        document.querySelectorAll('.cart-custom-field-billing-group,.cart-custom-field-billing').forEach(function(field) {
          field.style.display = 'block';
        });
        document.querySelectorAll('.cart-custom-field-billing.cart-custom-field-billing-required input').forEach(function(input) {
          input.required = true;
          input.classList.add('required');
        });
        document.querySelectorAll('.cart-custom-field-billing.cart-custom-field-billing-required select').forEach(function(input) {
          input.required = true;
          input.classList.add('required');
        });
      } else {
        document.querySelectorAll('cart-custom-field-billing-group,.cart-custom-field-billing').forEach(function(field) {
          field.style.display = 'none';
        });
        document.querySelectorAll('.cart-custom-field-billing input').forEach(function(input) {
          input.value = '';
        });
        document.querySelectorAll('.cart-custom-field-billing select').forEach(function(input) {
          input.selectedIndex = 0; 
        });
        document.querySelectorAll('.cart-custom-field-billing.cart-custom-field-billing-required input').forEach(function(input) {
          input.required = false;
          input.classList.remove('required');
        });
        document.querySelectorAll('.cart-custom-field-billing.cart-custom-field-billing-required select').forEach(function(input) {
          input.required = false;
          input.classList.remove('required');
        });
  


        document.querySelectorAll('.cart-custom-field-billing-group .invalid-feedback span').forEach(function(iva_error) {
          iva_error.setAttribute("hidden", true);
        });

        
  
        // Svuota il valore dell'input prima di inviare la richiesta
        var formData = new FormData();
        formData.append("attributes[Vuoi ricevere la fattura?]", checkedValue);
        formData.append("attributes[Ragione sociale]", "");
        formData.append("attributes[Indirizzo]", "");
        formData.append("attributes[CAP]", "");
        formData.append("attributes[Città]", "");
        formData.append("attributes[Provincia]", "");
        formData.append("attributes[Partita IVA]", "");
        formData.append("attributes[Codice SDI]", "");
        formData.append("attributes[Indirizzo PEC]", "");
        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          body: formData
        })
        .then(response => response.json())
        .then(data => console.log(data))
        .catch(error => console.error('Error:', error));
  
        // Uscire dalla funzione per evitare la doppia richiesta
        return;
      }
  
      // Invio del valore dell'input radio al server
      var formData = new FormData();
      formData.append("attributes[Vuoi ricevere la fattura?]", checkedValue);
  
      // Se il valore selezionato è 'Si', aggiungi anche il valore dell'input aggiuntivo
      if (checkedValue === 'Si') {
        var ragioneSocialeValue = document.querySelector('input[name="attributes[Ragione sociale]"]').value;
        formData.append("attributes[Ragione sociale]", ragioneSocialeValue);

        var indirizzoValue = document.querySelector('input[name="attributes[Indirizzo]"]').value;
        formData.append("attributes[Indirizzo]", indirizzoValue);

        var capValue = document.querySelector('input[name="attributes[CAP]"]').value;
        formData.append("attributes[CAP]", capValue);

        var cittaValue = document.querySelector('input[name="attributes[Città]"]').value;
        formData.append("attributes[Città]", cittaValue);

        var provinciaValue = document.querySelector('select[name="attributes[Provincia]"]').value;
        formData.append("attributes[Provincia]", provinciaValue);

        var partitaIVAValue = document.querySelector('input[name="attributes[Partita IVA]"]').value;
        formData.append("attributes[Partita IVA]", partitaIVAValue);

        var codiceSDIValue = document.querySelector('input[name="attributes[Codice SDI]"]').value;
        formData.append("attributes[Codice SDI]", codiceSDIValue);

        var indirizzoPECValue = document.querySelector('input[name="attributes[Indirizzo PEC]"]').value;
        formData.append("attributes[Indirizzo PEC]", indirizzoPECValue);
        console.log('indirizzoPECValue',indirizzoPECValue);
      }
  
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => console.log(data))
      .catch(error => console.error('Error:', error));
    });
  });

  // Trigger del cambiamento iniziale
  document.querySelectorAll('.custom-radio-partita-iva').forEach(function(element) {
    var event = new Event('change');
    element.dispatchEvent(event);
  });



document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('a.card').forEach(link => {
    link.addEventListener('click', function (e) {
    
      
      const href = link.getAttribute('href');

      
      // Verifica che il link sia effettivamente verso un prodotto
      if (/^\/collections\/.*\/products\/.*/.test(href)) {
        const parts = href.split('/');
        const productHandle = parts[parts.length - 1];
        const eventGTM ={
          event: 'select_item',
          ecommerce: {
            item_list_name: 'collection_page', // o il nome reale della collezione, se lo hai
            items: [
              {
                item_id: productHandle,
                item_name: productHandle.replace(/-/g, ' '),
                index: Array.from(document.querySelectorAll('a.card')).indexOf(link)
              }
            ]
          }
        };
        console.log(eventGTM);
        dataLayer.push(eventGTM);
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const stickyBuy = document.querySelector(".wt-product__sticky-buy");
  const addToCart = document.querySelector(".js-add-to-cart.product-form__submit");

  if (stickyBuy && addToCart) {
    stickyBuy.addEventListener("click", function (e) {
      e.preventDefault(); // opzionale, se non vuoi comportamento di default
      addToCart.click();
    });
  }
});

/* SYNESTHESIA CUSTOM CODE END */
